<template>
  <div class="contents">
    <div class="d-flex section-title-with-back">
      <img src="@/assets/images/Icon awesome-list-ul_bk.png" alt width="27.3" height="27.3" />
      <p class="title-bk">生徒の所属を登録</p>
    </div>
    <div class="container">
      <label>いつからAAA+を利用できるようにするかを選択してください</label>
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(confirmEdited)" ref="form">
          <table class="table table-form">
            <tbody>
              <tr>
                <th scope="row">登録する生徒数：</th>
                <td />
                <td class="total">{{ totalReadyStudents }}</td>
              </tr>
              <tr v-for="activation in activations" :key="activation.id">
                <th scope="row" colspan="3">
                  <input
                    type="radio"
                    class="body-radio"
                    name="activation"
                    :id="activation.key"
                    :value="activation.id"
                    v-model="activationId"
                    @change="choseActivationId"
                  />
                  <label class="body-radio" :for="activation.key">
                    {{ activation.name }}
                  </label>
                  <label class="red-warning-option" :for="activation.key" v-if="activation.note">
                    {{ activation.note }}
                  </label>
                  <label class="red-warning-option" :for="activation.key" v-if="activation.subNote">
                    {{ activation.subNote }}
                  </label>
                  <v-select
                    tag="div"
                    v-model="preRegistrationMonth"
                    placeholder="選択してください"
                    class="select-control"
                    :clearable="false"
                    :options="activationId == '3' ? getActivationMonths : []"
                    label="text"
                    v-if="activation.id == '3'"
                  >
                  </v-select>
                </th>
                <td />
                <td />
              </tr>
            </tbody>
          </table>
          <div class="text-center">
            <button type="submit" class="btn-red" :disabled="!canConfirmImport">登録</button>
          </div>
        </form>
      </ValidationObserver>
      <label class="extra-explanation">
        ※希望する生徒IDが既に利用されていた場合はエラーとなり、その生徒は登録されません。生徒IDをクリックして利用可能なIDに変更してください。
      </label>
      <PopUpHolder
        ref="popup_holder"
        no-close-on-esc
        no-close-on-backdrop
        :green-button-title="fullyImported ? 'リストに戻る' : '生徒管理に戻る'"
        @greenClick="popupConfirmed"
      >
        <template v-slot:header>AAA+に登録</template>

        <template v-slot:body v-if="fullyImported">
          生徒を登録しました <br />登録エラー：{{ invalidStudents.length }} 件
        </template>
        <template v-slot:body v-else> お疲れ様でした <br />取り込んだ生徒全てを登録しました </template>
      </PopUpHolder>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import store from '@/store/index.js';
import { ValidationObserver } from 'vee-validate';
import PopUpHolder from '@/components/popups/PopUpHolder.vue';

export default {
  data() {
    return {
      activationId: null,
      preRegistrationMonth: null,
      invalidStudents: [],
    };
  },
  components: {
    ValidationObserver,
    PopUpHolder,
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    if (store.getters['student_importer/allStudentAlreadyReady']) {
      next();
    } else {
      next({ name: 'student' });
    }
  },
  computed: {
    fullyImported() {
      return this.invalidStudents.length > 0;
    },
    canConfirmImport() {
      if (this.activationId == '3') {
        return this.preRegistrationMonth != null;
      }
      return this.activationId != null;
    },
    ...mapState({
      activations: (state) => state.activation.activations,
    }),
    ...mapGetters('student_importer', ['totalReadyStudents']),
    ...mapGetters('activation', ['getActivationMonths']),
  },
  methods: {
    choseActivationId() {
      this.$logger.debug('Picked Activation Id: ' + this.activationId);
      if (this.activationId != '3') {
        this.preRegistrationMonth = null;
      }
    },
    confirmEdited() {
      let payload = {
        activationId: this.activationId,
        preRegistrationMonth: this.preRegistrationMonth,
      };
      this.finishImportingStudents(payload)
        .then((response) => {
          if (response.length > 0) {
            this.$logger.debug('Importing has some invalid data: ' + JSON.stringify(response));
            this.invalidStudents = response;
          } else {
            this.$logger.debug('Importing successfully!');
          }
          this.$refs['popup_holder'].show();
        })
        .catch((error) => {
          this.$logger.debug('Importing failed with error ' + error);
        });
    },
    popupConfirmed() {
      if (this.invalidStudents && this.invalidStudents.length > 0) {
        this.$router.push({ name: 'student-import' });
      } else {
        this.$router.push({ name: 'student' });
      }
    },
    ...mapActions('student_importer', ['finishImportingStudents']),
  },
};
</script>

<style scoped>
.btn-confirm {
  margin-left: 0px;
}
.table-form {
  margin-left: 20px;
  margin-top: 20px;
  width: 95%;
}
.total {
  width: 80%;
}
.body-radio {
  margin-right: 5px;
}
.red-warning-option {
  color: red;
  font-size: 11px;
}
.extra-explanation {
  font-size: 10px;
}
.select-control {
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 12px;
  width: 200px;
}
</style>
